declare namespace $ {

	type $mol_view__sub_shm_ba_filter_panel_1 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['filters_head_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_filter_panel_2 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['filter_summary_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_filter_panel_3 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['filters_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_ba_date__period_shm_ba_filter_panel_4 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['period'] >
		,
		ReturnType< $shm_ba_date['period'] >
	>
	type $shm_ba_date__period_all_shm_ba_filter_panel_5 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['period_all'] >
		,
		ReturnType< $shm_ba_date['period_all'] >
	>
	type $mol_view__sub_shm_ba_filter_panel_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_search__hint_shm_ba_filter_panel_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_search['hint'] >
	>
	type $mol_search__query_shm_ba_filter_panel_8 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['search_query_draft'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_search__submit_shm_ba_filter_panel_9 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['search_submit'] >
		,
		ReturnType< $mol_search['submit'] >
	>
	type $mol_search__clear_shm_ba_filter_panel_10 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['search_clear'] >
		,
		ReturnType< $mol_search['clear'] >
	>
	type $mol_button_minor__hint_shm_ba_filter_panel_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_ba_filter_panel_12 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['search_submit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_ba_filter_panel_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_ba_filter_panel_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_filter_panel_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_expand__checked_shm_ba_filter_panel_16 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['summary_expanded'] >
		,
		ReturnType< $mol_check_expand['checked'] >
	>
	type $mol_check_expand__expandable_shm_ba_filter_panel_17 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_check_expand['expandable'] >
	>
	type $mol_check_icon__hint_shm_ba_filter_panel_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__Icon_shm_ba_filter_panel_19 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['Process_monitor_toggle_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_shm_ba_filter_panel_20 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['process_monitor_opened'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_button_minor__title_shm_ba_filter_panel_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_ba_filter_panel_22 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['filter_reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_ba_filter_panel_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_ba_filter_section__title_content_shm_ba_filter_panel_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_ba_filter_section['title_content'] >
	>
	type $shm_ba_filter_section__Expand_shm_ba_filter_panel_25 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_ba_filter_section['Expand'] >
	>
	type $shm_ba_filter_section__tools_shm_ba_filter_panel_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_ba_filter_section['tools'] >
	>
	type $shm_ba_filter_section__content_shm_ba_filter_panel_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_ba_filter_section['content'] >
	>
	type $shm_ba_filter_section__title_shm_ba_filter_panel_28 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_filter_section['title'] >
	>
	type $shm_ba_filter_section__Expand_shm_ba_filter_panel_29 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_ba_filter_section['Expand'] >
	>
	type $shm_ba_filter_section__tools_shm_ba_filter_panel_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_ba_filter_section['tools'] >
	>
	type $shm_ba_filter_section__content_shm_ba_filter_panel_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_ba_filter_section['content'] >
	>
	type $shm_ba_filter_section__title_shm_ba_filter_panel_32 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_filter_section['title'] >
	>
	type $shm_ba_filter_section__table_shm_ba_filter_panel_33 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['tags'] >
		,
		ReturnType< $shm_ba_filter_section['table'] >
	>
	type $shm_ba_filter_section__filter_shm_ba_filter_panel_34 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['tags_filter'] >
		,
		ReturnType< $shm_ba_filter_section['filter'] >
	>
	type $shm_ba_filter_section__title_shm_ba_filter_panel_35 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_filter_section['title'] >
	>
	type $shm_ba_filter_section__table_shm_ba_filter_panel_36 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['message_types'] >
		,
		ReturnType< $shm_ba_filter_section['table'] >
	>
	type $shm_ba_filter_section__filter_shm_ba_filter_panel_37 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['message_types_filter'] >
		,
		ReturnType< $shm_ba_filter_section['filter'] >
	>
	type $shm_ba_filter_section__title_shm_ba_filter_panel_38 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_filter_section['title'] >
	>
	type $shm_ba_filter_section__table_shm_ba_filter_panel_39 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['source_types'] >
		,
		ReturnType< $shm_ba_filter_section['table'] >
	>
	type $shm_ba_filter_section__filter_shm_ba_filter_panel_40 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['source_types_filter'] >
		,
		ReturnType< $shm_ba_filter_section['filter'] >
	>
	type $shm_ba_filter_section__title_shm_ba_filter_panel_41 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_filter_section['title'] >
	>
	type $shm_ba_filter_section__table_shm_ba_filter_panel_42 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['sources'] >
		,
		ReturnType< $shm_ba_filter_section['table'] >
	>
	type $shm_ba_filter_section__filter_shm_ba_filter_panel_43 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['sources_filter'] >
		,
		ReturnType< $shm_ba_filter_section['filter'] >
	>
	type $shm_ba_filter_section__title_shm_ba_filter_panel_44 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_filter_section['title'] >
	>
	type $shm_ba_filter_section__table_shm_ba_filter_panel_45 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['authors'] >
		,
		ReturnType< $shm_ba_filter_section['table'] >
	>
	type $shm_ba_filter_section__filter_shm_ba_filter_panel_46 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['authors_filter'] >
		,
		ReturnType< $shm_ba_filter_section['filter'] >
	>
	type $mol_view__sub_shm_ba_filter_panel_47 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_ba_filter_panel_48 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['filter_summary_more_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_ba_filter_panel_49 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_panel['filter_summary_more'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_ba_filter_panel extends $mol_page {
		filters_head_rows( ): readonly(any)[]
		Filters_head( ): $mol_view
		filter_summary_content( ): readonly(any)[]
		Filter_summary( ): $mol_view
		summary_expanded( next?: boolean ): boolean
		Process_monitor_toggle_icon( ): $mol_icon_clock_fast
		process_monitor_opened( next?: boolean ): boolean
		filter_reset( next?: any ): any
		filters_rows( ): readonly(any)[]
		Filters( ): $mol_view
		Period_icon( ): $mol_icon_calendar
		Period_filter( ): $shm_ba_date
		search_index_status( ): string
		Search_index_status( ): $mol_view
		search_query_draft( next?: string ): string
		search_submit( next?: any ): any
		search_clear( next?: any ): any
		Search_filter( ): $mol_search
		Search_submit_icon( ): $mol_icon_magnify
		Search_submit( ): $mol_button_minor
		Search_row( ): $mol_view
		tags( ): any
		tags_filter( next?: Record<string, any> ): Record<string, any>
		message_types( ): any
		message_types_filter( next?: Record<string, any> ): Record<string, any>
		source_types( ): any
		source_types_filter( next?: Record<string, any> ): Record<string, any>
		sources( ): any
		sources_filter( next?: Record<string, any> ): Record<string, any>
		authors( ): any
		authors_filter( next?: Record<string, any> ): Record<string, any>
		filter_summary_label( id: any): string
		filter_summary_more_title( ): string
		filter_summary_more( next?: any ): any
		has_source( ): boolean
		state( ): any
		data( ): any
		period( next?: ({ 
			'from': string,
			'to': string,
		})  ): ({ 
			'from': string,
			'to': string,
		}) 
		period_all( ): ({ 
			'from': string,
			'to': string,
		}) 
		title( ): string
		title_content( ): readonly(any)[]
		Filters_title( ): $mol_view
		Summary_expand( ): $mol_check_expand
		Process_monitor_toggle( ): $mol_check_icon
		Filter_reset( ): $mol_button_minor
		body( ): readonly(any)[]
		Empty( ): $mol_view
		Period_section( ): $shm_ba_filter_section
		Search_section( ): $shm_ba_filter_section
		Tags_section( ): $shm_ba_filter_section
		Message_types_section( ): $shm_ba_filter_section
		Source_types_section( ): $shm_ba_filter_section
		Sources_section( ): $shm_ba_filter_section
		Authors_section( ): $shm_ba_filter_section
		Filter_summary_label( id: any): $mol_view
		Filter_summary_more( ): $mol_button_minor
	}
	
}

//# sourceMappingURL=panel.view.tree.d.ts.map